
import styles from './Honer.module.scss';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableCard } from "../../../components";
import common from '../../../common';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Honer({ cateIdx, type }) {


    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);

    const tableLoadData = {
        tableType: 'Honer',
        type: type,
        cate: [cateIdx]
    };


    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_table`, tableLoadData , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data);
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    
    const pageSize = 20;
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'contents' },
        { label: '작성자', value: 'member' },
    ], []);

    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>명예의 전당</span>
                <TableCard  data={data} pageSize={pageSize} categoryOptions={categoryOptions} type="Editor" />
                
            </div>
        </>
    );
}

export default Honer;